<template>
	<div class="page"
		:style="[{ backgroundImage: `url(${item.bgUrl})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
		<img class="logoUrl" :style="{width: item.logoWidth + 'px'}" :src="item.logoUrl" alt="" srcset="" />
		<img class="titleUrl" :style="{width: item.titleWidth + 'px'}" :src="item.titleUrl" alt="" srcset="" />
		<div class="contentUrl"
			:style="[{ backgroundImage: `url(${item.contentUrl})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
			<div class="zhTitle" :style="{color: item.titleColor}">{{item.zhTitle}}</div>
			<div class="enTitle" :style="{color: item.titleColor}">{{item.enTitle}}</div>
			<div class="textUrl"
				:style="[{ backgroundImage: `url(${item.textUrl})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
				<div :style="{color: item.contentColor}" v-for="(row, index) in item.contentList" :key="index" class="rowList">
					{{row.name}}：{{row.info}}
				</div>
			</div>
			<div class="fwZhTitle" :style="{color: item.title1Color}">{{item.feZhTitle}}</div>
			<div class="fwEnTitle" :style="{color: item.title1Color}">{{item.fwEnTitle}}</div>
			<div class="textUrl1"
				:style="[{ backgroundImage: `url(${item.textUrl})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
				<div :style="{color: item.contentColor}" class="rowList">你所查询的编号:11816433851307519的产品为姜康官方正品，请放心使用，感谢您的支持!</div>
			</div>
		</div>
		
		<div class="anUrl" :style="[{ backgroundImage: `url(${item.anUrl})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">我要打假</div>
		<div class="address">湖北省 荆门市</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		components: {

		},
		props: {
			item: {
			  type: Object
			},
			verState: Number,
			handleLink: String,
			handle: String,
			query: {
			  type: String
			},
			h: {
			  String
			},
			codeData:{
			  type: Object
			}
		},
		mounted() {
			console.log(this.item)
		},
		methods: {

		},
		computed: {

		},
	}
</script>
<style scoped>
	.page {
		width: 100%;
		height: 100vh;
		position: relative;
		padding: 120px 25px 55px;
		box-sizing: border-box;
	}

	.logoUrl {
		/* height: auto; */
		/* width: 45px; */
		/* height: 112px; */
		position: absolute;
		left: 25px;
		top: 40px;
	}

	.titleUrl {
		/* width: 214px;
		height: 82px; */
	}

	.contentUrl {
		margin-top: 15px;
		width: 100%;
		box-sizing: border-box;
		padding: 40px 30px;

		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
	}

	.textUrl {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
		box-sizing: border-box;
		padding: 17px 10px;
	}

	.zhTitle,
	.fwZhTitle {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 20px;
		color: #0D525B;
		text-align: left;
	}

	.enTitle,
	.fwEnTitle {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 12px;
		color: #0D525B;
		text-align: left;
		margin: 5px 0 16px;
	}

	.textUrl1 {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
		box-sizing: border-box;
		padding: 17px 10px;
	}

	.fwZhTitle {
		margin-top: 25px;
	}

	.rowList {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 12px;
		color: #05272B;
		line-height: 24px;
		text-align: left;
	}
	
	.anUrl {
		width: 170px;
		height: 47px;
		display: flex;
		align-items: center;
		justify-content: center;
		
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 18px;
		color: #0C2C30;
		
		margin: 20px auto;
	}
	
	.address {
		text-align: center;
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size: 15px;
		color: #0C2C30;
	}
</style>